const tableStyle = {
  border: "0.01px solid black",
  width: "71.95%",
  position: "relative",
};
const headerStyle = {
  padding: "1px 4px",
  width: "28%",
  textAlign: "center",
  fontFamily: "GE-BodyCopyHighlight, sans-serif",
};
const cellStyle = {
  width: "30%",
  height: "2.5cm",
  borderTop: "1px solid black",
  padding: "6px"
};
const WPS_images = ({ pdf, Imageheaders, images }) => {
  const isTabesheet = pdf[0]?.wld_WPSType === "Tubesheet";
  return (
    <table className="WPSTable12" style={tableStyle}>
      {" "}
      <tbody>
        {isTabesheet && (
          <tr>
            {" "}
            {Imageheaders.map((header, index) => (
              <th
                key={header}
                style={{
                  ...headerStyle,
                  borderLeft: index === 0 ? "none" : "0.01px dashed black",
                  borderBottom: "1px black solid"
                }}
              >
                {header}{" "}
              </th>
            ))}{" "}
          </tr>
        )}{" "}
        <tr>
          {" "}
          {images.map((row, index) => (
            <td
              key={row || `empty-${index}`}
              style={{ ...cellStyle, borderLeft: index === 0 ? "none" : "" }}
            >
              {row && (
                <img className="WPSimgsizebig" src={row} alt="WPS Image" />
              )}{" "}
            </td>
          ))}{" "}
        </tr>{" "}
      </tbody>{" "}
    </table>
  );
};
export default WPS_images;
